import { Directive, ElementRef, HostListener, Output, EventEmitter, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[isOverflow]'
})
export class IsOverflowDirective implements AfterViewInit {
  @Output() overflowChange = new EventEmitter<boolean>();

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.checkOverflow();
  }

  @HostListener('window:resize')
  onResize() {
    this.checkOverflow();
  }

  private checkOverflow() {
    const element = this.el.nativeElement;
    const isOverflowing = element.scrollWidth > element.clientWidth;
    this.overflowChange.emit(isOverflowing);
  }
}
